
import { useEffect, useState } from "react";
import { useRouter } from "next/router";

const roleRoutes = [
  { prefix: "/student", role: "student" },
  { prefix: "/instructor", role: "instructor" },
  { prefix: "/hr-admin", role: "hr" },
  { prefix: "/admins", role: "admin" }
];

const excludedRoutes = [
  "/student/student-enquiry-details",
  "/hr-admin/bulk-resume-analyzer",
];

const ProtectedRoute = ({ children }) => {
  const router = useRouter();
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const user = JSON.parse(localStorage.getItem("user"));

      for (const excluded of excludedRoutes) {
        if (router.pathname.startsWith(excluded)) {
          setAllowed(true);
          return;
        }
      }
      let isAllowed = true;

      for (const route of roleRoutes) {
        if (router.pathname.startsWith(route.prefix)) {
          if (!user || user.role !== route.role) {
            isAllowed = false;


            let loginPath = "/login";
            if (route.role === "hr") loginPath = "/login?role=hr";
            else if (route.role === "instructor") loginPath = "/login?role=instructor";
            else if (route.role === "admin") loginPath = "/login?role=admin";

            router.replace(loginPath);
          }
          break;
        }
      }


      setAllowed(isAllowed);
    }
  }, [router.pathname]);

  if (!allowed) return null;

  return children;
};

export default ProtectedRoute;
